import { checkPointService } from 'src/modules/Distances/components/shared/Steps/GPX/services';
import { CheckPoint } from 'src/modules/Distances/components/shared/Steps/GPX/types';

export const deleteCheckpointCoordinates = (checkpoint: CheckPoint) => {
  checkPointService.deleteCheckPointCoordinates(checkpoint);
};
